import React from 'react'
import styles from './ScopeFilter.module.scss'
import CheckBoxes from './CheckBoxes'
import { ScopeFilterProps } from './ScopeFilter.types'
import { DropdownSelect, DropdownSelectOptionType } from 'components/common'
import { selectStyles } from './select-styles'
import { capitalize } from 'utilities'
import { FilterTypes } from 'models'

const filterOptions: DropdownSelectOptionType[] = Object.keys(FilterTypes).map(key => ({
  value: FilterTypes[key],
  label: FilterTypes[key]
}))
const ScopeFilter = (props: ScopeFilterProps) => {
  const {
    filter,
    setFilterProp
  } = props

  return (
    <div className={styles.scopeFilterContainer}>
      <div className={styles.filterDropdown}>
        <label>Filter</label>
        <DropdownSelect
          styles={selectStyles}
          isMulti={false}
          options={filterOptions}
          closeMenuOnSelect={true}
          placeholder='Select filter type'
          value={{
            label: capitalize(filter.type, true),
            value: filter.type
          }}
          onChange={({ value: type }: DropdownSelectOptionType) => {
            setFilterProp({ type })
          }}
        />
      </div>

      {filter.type &&
        <div className={styles.valueContainer}>
          <label>values</label>

          <CheckBoxes
            store={filter.type.toLowerCase() === FilterTypes.PROJECTS.toLowerCase()
              ? 'projects'
              : 'brands'}
            filter={filter}
            setFilterProp={setFilterProp}
          />

        </div>
      }
    </div>
  )
}

export default ScopeFilter
